import { render } from "./Utenti.vue?vue&type=template&id=469de249&scoped=true"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"

import "./Utenti.vue?vue&type=style&index=0&id=469de249&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469de249"]])

export default __exports__